import { Box, Button, Chip, ClickAwayListener, Typography } from '@mui/material'
import React from 'react'
import { filterByTagActions } from '../redux/store'
import { useDispatch, useSelector } from 'react-redux'
import { DOMAIN, api } from '../utils/api'
import axios from 'axios'
import { handleError } from '../utils/error'
import { getFromStorage } from '../utils/storage'
import { borderFormat, mainGreen, mainRed } from '../utils/color'

export default function FilterByTag() {
	const { currentUser } = useSelector((state) => state.currentUser)
	const token = getFromStorage('current-user')?.accessToken
	const dispatch = useDispatch()
	const { tagList, adminStore } = useSelector((state) => state.filterByTag)

	// ------GET FILTER TAG LIST------
	const getFilterTagList = React.useCallback(
		async function () {
			try {
				const response = await axios({
					url:
						currentUser.role === 'admin' || currentUser.role === 'director' || currentUser.role === 'assistant'
							? `${DOMAIN}/orders-admin/${adminStore}`
							: api.GET_ORDERS,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				let tagFilter = []
				response.data.forEach((order) => (tagFilter = tagFilter.concat(order.tag)))
				const uniqueTagFilter = [...new Map(tagFilter.map((v) => [v.name, v])).values()]
				const getTagsResponse = await axios({
					url:
						currentUser.role === 'admin' || currentUser.role === 'director' || currentUser.role === 'assistant'
							? `${DOMAIN}/storeManager/tags/${adminStore}`
							: `${DOMAIN}/storeManager/tags/${currentUser.store}`,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				getTagsResponse.data.forEach((tag) => {
					uniqueTagFilter.forEach((item) => {
						if (item.name === tag.name) {
							item.index = tag.index
						}
					})
				})
				dispatch(filterByTagActions.getTagList(uniqueTagFilter))
			} catch (error) {
				handleError(error)
			}
		},
		[token, dispatch, currentUser.store, adminStore, currentUser.role],
	)

	return (
		<ClickAwayListener
			onClickAway={() => {
				dispatch(filterByTagActions.hideFilterByTag())
			}}>
			<Box sx={{ maxWidth: '1200px', margin: '0 auto' }}>
				<Typography
					sx={{
						textAlign: 'center',
						color: '#fff',
						background: mainGreen,
						padding: '5px 0',
						borderTopRightRadius: '10px',
						borderTopLeftRadius: '10px',
					}}>
					BỘ LỌC TAG
				</Typography>
				<Box
					onClick={(e) => {
						e.stopPropagation()
					}}
					onTouchEnd={(e) => {
						e.stopPropagation()
					}}
					sx={{
						borderLeft: borderFormat,
						borderRight: borderFormat,
						background: '#fff',
						padding: '20px 20px 0',
					}}>
					{tagList.length === 0 && (
						<Box>
							<Typography>Chưa có tag</Typography>
						</Box>
					)}
					{tagList.length > 0 &&
						[...tagList]
							.sort((a, b) => a.index - b.index)
							.map((tag) => {
								return (
									<Chip
										key={tag.index}
										label={tag.name}
										sx={{
											'&:hover': {
												backgroundColor: tag.check ? tag.color : undefined,
											},
											cursor: 'pointer',
											mr: 1,
											mt: 1,
											backgroundColor: tag.check ? tag.color : undefined,
											color: tag.check ? '#fff' : undefined,
										}}
										onClick={() => {
											dispatch(filterByTagActions.checkTag(tag.index))
										}}
									/>
								)
							})}

					<Box
						sx={{
							display: 'flex',
							justifyContent: 'space-between',
						}}>
						<Button
							size='small'
							variant='outlined'
							sx={{
								mt: 3,
								mb: 2,
								width: '45%',
								color: mainRed,
								borderColor: mainRed,
								'&:hover': {
									borderColor: mainRed,
								},
							}}
							onClick={() => {
								dispatch(filterByTagActions.unCheckAll())
							}}>
							Bỏ chọn tất cả
						</Button>
						<Button
							size='small'
							variant='outlined'
							sx={{
								mt: 3,
								mb: 2,
								width: '45%',
								color: mainGreen,
								borderColor: mainGreen,
								'&:hover': {
									borderColor: mainGreen,
								},
							}}
							onClick={() => {
								getFilterTagList()
							}}>
							Làm mới
						</Button>
					</Box>
				</Box>
			</Box>
		</ClickAwayListener>
	)
}
